import { TranslatedString } from 'lemunzo-api';
import {
    AddedElementModel,
    AddedElementVisibility,
    ElementType,
} from './added-element-model';

/**
 * Enum representing keys for the properties of the InputElementModel.
 *
 * @description
 * These values are used at multiple places within the codebase for generating clients form
 */
export enum InputElementModelKeys {
    VISIBLE = 'visible',
    REQUIRED = 'required',
    NAME = 'name',
    LABEL = 'label',
    TYPE_IN_HTML = 'typeInHTML',
    PLACEHOLDER = 'placeholder',
    MIN = 'min',
    MAX = 'max',
}

export enum InputHTMLTypes {
    TEXT = 'text',
    NUMBER = 'number',
    EMAIL = 'email',
    TEL = 'tel',
    DATE = 'date',
}

export type InputMinMaxType = number | Date | undefined;

/**
 * Represents a model for an input-text form element, extending the base AddedElementModel.
 */
export class InputElementModel extends AddedElementModel {
    typeInHTML: InputHTMLTypes;
    placeholder: TranslatedString;
    /**
     * For inputs of type 'text', 'email' and 'tel' -> Refers to attribute 'minlength'
     * For inputs of type 'number' and 'date' -> Refers to attribute 'min'
     *
     * See @link(https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attributes)
     */
    min: InputMinMaxType = undefined;
    /**
     * For inputs of type 'text', 'email' and 'tel' -> Refers to attribute 'maxlength'
     * For inputs of type 'number' and 'date' -> Refers to attribute 'max'
     *
     * See @link(https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attributes)
     */
    max: InputMinMaxType = undefined;

    constructor(
        name: TranslatedString,
        label: TranslatedString,
        typeInHTML: InputHTMLTypes,
        placeholder: TranslatedString,
        required: boolean = false,
        visible: AddedElementVisibility = AddedElementVisibility.AlwaysEditable,
        deletable: boolean = true,
        defaultElement: boolean = false,
        min: number | Date | undefined = undefined,
        max: number | Date | undefined = undefined
    ) {
        super(
            ElementType.Input,
            name,
            label,
            required,
            visible,
            deletable,
            defaultElement
        );
        this.typeInHTML = typeInHTML;
        this.placeholder = placeholder;
        this.min = min;
        this.max = max;
    }
}
